<template>
    <div
        v-if="shouldShowTutorial"
        class="d-flex flex-row align-center youtube-playlist"
    >
        <div
            class="d-flex flex-row align-center youtube-inner"
            @click="() => redirectToPlaylist(this.videoId, this.playlistId)"
        >
            <img
                class="mr-2 white--text"
                width="40px"
                onload="SVGInject(this)"
                src="/images/_SVGs/play-circle-outline.svg"
            />
            <a href="javascript:void(0)">{{ $t("b2b.watch-tutorial") }}</a>
        </div>
    </div>
</template>

<script>
import mixinTutorials from "@mixins/b2b/tutorials.js";

export default {
    mixins: [mixinTutorials],
    props: {
        moduleId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        shouldShowTutorial() {
            return this.playlistId !== null && this.playlistId !== undefined;
        },
        userLanguage() {
            return this.$store.getters["auth/getState"].languageCode;
        }
    },
    watch: {
        userLanguage: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.updatePlaylistId();
                }
            }
        }
    },
    methods: {
        updatePlaylistId() {
            let authModules = this.$store.getters["auth/getState"].modules;
            let vi = authModules.find((e) => e.moduleId == this.moduleId);

            if (vi && vi.youtubePlaylist) {
                const matchingPlaylist = vi.youtubePlaylist.find(
                    playlist => playlist.languageCode.toLowerCase() === this.userLanguage.toLowerCase()
                );

                if (matchingPlaylist) {
                    this.playlistId = matchingPlaylist.youtubePlaylist;
                    this.getFirstVideoFromPlaylist();
                } else {
                    this.playlistId = null;
                }
            }
        }
    },
    mounted() {
        this.updatePlaylistId();
    },
};
</script>

<style scoped>
.youtube-playlist {
    margin-bottom: 20px;
    max-width: 150px;
}

.youtube-inner {
    cursor: pointer;
}
</style>
